import useQueryErrorHandler from 'core/hooks/useQueryErrorHandler';
import { useConfig } from '../../../../../../resources/config';
import { gql, useMutation } from '@apollo/client';

const pushNotificationMutationDocument = gql`
    mutation pushNotificationToken($data: PushNotificationTokenInput!) {
        pushNotificationToken(data: $data) {
            device_type
            token
        }
    }
`;

export const useMutationPushNotificationToken = () => {
    const { appType } = useConfig();
    const { errorHandler } = useQueryErrorHandler();

    const [mutate] = useMutation(pushNotificationMutationDocument, {
        onError: (error) => {
            console.log('ERROR SAVING PUSH NOTIFICATIONS TOKEN', { error });
            errorHandler(error);
        },
    });

    const savePushNotificationToken = (device_type: string, token: string) => {
        const data = {
            device_type: device_type,
            token: token,
            application_type: appType,
        };

        mutate({ variables: { data } });
    };

    return { savePushNotificationToken };
};
